export const LAST_USED_ACCOUNT_STORAGE_KEY = 'lastUsedAccount';
export const THEME_MODE_STORAGE_KEY = 'superfunnelThemeMode';
